import Pets from './pets';

export default Pets;